"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _StyledTypography = require("../../StyledTypography");

var _StyledLayout = require("../../StyledLayout");

var _Modal = _interopRequireDefault(require("./Modal"));

var _Elements = require("../../StyledButton/Elements");

var ConfirmationDialog = function ConfirmationDialog(_ref) {
  var title = _ref.title,
      body = _ref.body,
      ctaText = _ref.ctaText,
      cancelText = _ref.cancelText,
      dialogType = _ref.dialogType,
      disclaimer = _ref.disclaimer,
      visible = _ref.visible,
      closeModal = _ref.closeModal,
      confirmAction = _ref.confirmAction;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    visible: visible,
    onCancel: closeModal,
    width: 332,
    mask: true
  }, title && /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    pb: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingMedium, {
    dark: true
  }, title)), /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
    dark: true,
    mb: "sm"
  }, body), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    mr: "xs",
    flexGrow: 1
  }, /*#__PURE__*/_react["default"].createElement(_Elements.OldButton, {
    fullWidth: true,
    bold: true,
    warning: dialogType === 'warning',
    onClick: function onClick() {
      confirmAction();
      closeModal();
    }
  }, ctaText || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "cta.confirm"
  }))), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    ml: "xs",
    flexGrow: 1
  }, /*#__PURE__*/_react["default"].createElement(_Elements.OldButton, {
    secondary: true,
    fullWidth: true,
    onClick: closeModal
  }, cancelText || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "cta.cancel"
  })))), disclaimer && /*#__PURE__*/_react["default"].createElement(_StyledTypography.Caption, {
    mediumGrey: true,
    mt: "xs"
  }, disclaimer));
};

ConfirmationDialog.defaultProps = {
  title: null,
  ctaText: null,
  cancelText: null,
  dialogType: null,
  disclaimer: null
};
ConfirmationDialog.propTypes = {
  title: _propTypes["default"].node,
  body: _propTypes["default"].node.isRequired,
  ctaText: _propTypes["default"].node,
  cancelText: _propTypes["default"].node,
  dialogType: _propTypes["default"].oneOf(['warning']),
  disclaimer: _propTypes["default"].node,
  visible: _propTypes["default"].bool.isRequired,
  closeModal: _propTypes["default"].func.isRequired,
  confirmAction: _propTypes["default"].func.isRequired
};
var _default = ConfirmationDialog;
exports["default"] = _default;